import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export type NotifyType = 'success' | 'error' | 'warning';

export interface NotifyPayload {
  title: string;
  message: string;
  type: NotifyType;
}

@Injectable({ providedIn: 'root' })
export class NotifyService {
  private notifySubject = new Subject<NotifyPayload | null>();
  notify$ = this.notifySubject.asObservable();

  private isOpen = false;

  show(payload: NotifyPayload) {
    if (this.isOpen) return;

    this.isOpen = true;

    this.notifySubject.next(null);
    setTimeout(() => {
      this.notifySubject.next(payload);
    });
  }

  clear() {
    this.isOpen = false;
    this.notifySubject.next(null);
  }

  error(message: string, title = 'Error') {
    this.show({ title, message, type: 'error' });
  }

  warning(message: string, title = 'Atención') {
    this.show({ title, message, type: 'warning' });
  }

  success(message: string, title = 'Éxito') {
    this.show({ title, message, type: 'success' });
  }
}

